import { accountMessagesStyles } from "@insite/content-library/Widgets/MyAccount/AccountMessages";
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

accountMessagesStyles.messagesAccordion = {
    css: css`
        width: 100%;
        > ${AccordionSectionPanel} {
            border: none;
        }
    `,
};

accountMessagesStyles.messagesAccordionSection = {
    panelProps: {
        css: css`
            max-height: 500px;
            overflow-y: auto;
        `,
    },
    titleTypographyProps: {
        css: css`
            color: ${getColor("secondary")} !important;
            font-weight: bold !important;
        `,
    },
};
accountMessagesStyles.messagesSection = {
    css: css`
        width: 99%;
    `,
};
